module.exports = __webpack_public_path__ + "img/bgcenter.c1d3caa.c1d3caac.jpg";